import React from "react";
const AddIcon = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "rgb(65, 71, 85)",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    p-id="3133"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m0-896C299.968 128 128 299.968 128 512s171.968 384 384 384 384-171.968 384-384S724.032 128 512 128z m192 448h-128v128c0 35.392-28.608 64-64 64a64 64 0 0 1-64-64v-128h-128a64 64 0 1 1 0-128h128v-128a64.021333 64.021333 0 0 1 128 0v128h128a64 64 0 0 1 64 64c0 35.392-28.608 64-64 64z"
      fill={color}
      p-id="3134"
    ></path>
  </svg>
);

export default AddIcon;
